import { render, staticRenderFns } from "./LabelProjectsReadOnly.vue?vue&type=template&id=33669920"
import script from "./LabelProjectsReadOnly.vue?vue&type=script&lang=js"
export * from "./LabelProjectsReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports